<template>
  <div id="app">
    <div class="body-overlay"></div>
    <Header />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
  components: {
    Header
  }
};
</script>
<style lang="scss">
@import "src/assets/css/circular-std.scss";
@import "src/assets/css/typography.scss";
body {
  background: white;
  color: black;
  font-size: 10px;
  letter-spacing: -0.05em;
  height: auto !important;
  * {
    box-sizing: border-box;
  }
  &.dark {
    color: white;
    background: $black;
    .bm-burger-bars {
      background-color: white;
    }
    .header {
      .primary-nav,
      .secondary-nav {
        a {
          &:before {
            background-color: white;
          }
        }
      }
    }
  }
  &.invert {
    color: white;
    transition: color 0.5s ease-in-out;
    .bm-burger-bars {
      background-color: white;
    }
    .body-overlay {
      opacity: 1;
    }
    &.dark {
      .body-overlay {
        opacity: 0;
      }
    }
    .header {
      .primary-nav,
      .secondary-nav {
        a {
          &:before {
            background-color: white;
          }
        }
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.body-overlay {
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $black;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
#app {
  //font-family: Circular, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
